import { useQuery } from "@tanstack/react-query";

import { gql } from "@examspark/api";
import { parseAwsJson } from "@examspark/common";
import { ParsedAppUserConfig } from "@examspark/types";

import { AppState } from "../../providers/app-context/appContextReducer";
import { useAppContext } from "../../providers/AppContext";

export const useQueryGetAppLicenseConfig = (state?: AppState) => {
  const [contextState] = useAppContext();

  state = state ?? contextState;

  return useQuery({
    queryKey: ["app-config", state.appLicense?.appKey, state.user?.id],
    enabled: !!state.appLicense?.appKey,
    queryFn: async () => {
      const appKeyId = state.appLicense?.appKey;
      const userId = state.user?.id;
      if (appKeyId == null || userId == null) return;

      const [appKey, appUser] = await Promise.all([
        gql.operations.app.getAppKey(appKeyId),
        gql.operations.app.getUserConfig(appKeyId, userId),
      ]);

      return {
        appLicenseConfig: parseAwsJson(appKey.config),
        appUserConfig:
          parseAwsJson<ParsedAppUserConfig>(appUser?.config) ?? undefined,
      };
    },
  });
};
